module.exports = __webpack_public_path__ + "static/media/paypal.e21e9cf5.svg";